module.exports = __webpack_public_path__ + "static/media/cellfinate_social_2.234f8a72.jpg";